<template lang="pug">
  div
    div(v-if="dadosVtn.status !== 'Aguardando cálculo' && dadosVtn.status !== 'AGUARDANDO_CALCULO' && dadosVtn.status.toUpperCase() !== 'CRIADO'")
      div(class="card-body")
        dados-modal-AP(
          :dadosVtn="dadosVtn"
          :processo="dadosVtn.processo",
        )
      app-divider(label="Observações:").margin10
      div(class="card-body margin10")
        p - Cálculos efetuados com base no DECRETO Nº 1.684, de 29 de JUNHO de 2021; Lei Estadual nº 8.878, de 8 de julho de 2019 e DECRETO Nº 1.190, DE 25 / 11 / 2020.
        p(v-if="dadosVtn.processo.tipo.codigo === 'ONEROSO'") - Reajuste pela UPFPA do em vigor e, caso opte pelo pagamento parcelado, será aplicados juros de {{dadosVtn.juros}}% ao ano.
        p(v-if="dadosVtn.processo.tipo.codigo === 'ONEROSO' && !(dadosVtn.respeitaLegislacaoAmbiental && dadosVtn.temDireitoRegularizacao)") - Caso opte pelo pagamento à vista, será aplicado um desconto de 20%.
        p(v-if="dadosVtn.respeitaLegislacaoAmbiental") - {{mensagemRespeitaLegislacaoAmbiental}}
        p(v-if="dadosVtn.temDireitoRegularizacao") - {{mensagemDireitoRegularizacao}}
    div(v-else)
      p Nenhuma informação disponível para este processo.
</template>

<script>
import utils from '@/utils/utils'
import AppDisplay from '@/components/AppDisplay'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import messages from '@/constants/messages'
import DadosModalAP from '../screens/analise/vtn/components/DadosModalAP.vue'

export default {
  components: {
    AppDisplay,
    AppLabel,
    AppDivider,
    DadosModalAP
  },

  data () {
    return {
      textoIfd: `
      Caso o número de módulos fiscais seja menor ou igual a um, ou maior ou igual a quinze, IFd = 1,17.\n
      Caso não se enquadre em nenhuma das condições anteriores, o IFd = 0,0571 * Número de Módulos Fiscais + 0,3129.`,
      mensagemDireitoRegularizacao: messages.TEM_DIREITO_REGULARIZACAO,
      mensagemRespeitaLegislacaoAmbiental: messages.RESPEITA_LEGISLACAO_AMBIENTAL
    }
  },

  methods: {
    formatTotal (valor) {
      return utils.padraoMoedaBrasil.format(valor)
    },

    formataMoeda (valor) {
      let formatado = valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      return formatado
    },

    formatarNumero (val, precision) {
      return utils.format(val, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision })
    },

    formataAnos: (valor) => valor > 1 ? `${valor} anos` : `${valor} ano`
  },

  computed: {
    dadosVtn () {
      return JSON.parse(this.$store.state.vtn.dadosVtn)
    },
    parcelasGeo () {
      return this.$store.state.vtn.dadosVtn?.calculosVtn?.dadosParcelaGeoVtn
    }
  }
}
</script>

<style>

  .conteudo {
    margin: 0px 15px;
    text-align: left;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    color: #2c3e50;
  }

  .dataLimite {
    margin-top: 20px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-weight: 400;
  }

  .card {
    margin-top: 5;
  }

  .row {
    display: flex;
    flex-direction: row;
  }

  .aling-center {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
  }

  .margin10 {
    margin: 10px;
  }

  .card .card-header {
    font-size: x-large;
    line-height: initial;
    padding: 23px 23px 0 23px;
  }

</style>



// WEBPACK FOOTER //
// src/components/AppDadosCalculoVtnAP.vue